export const solveLinkifyHtmlOptions = {
  rel: 'noreferrer',
  target: '_blank',
  truncate: 42,
} as const satisfies Parameters<typeof import('linkify-html')>[1];
